import numberBase from './numberFormats/base';

const numberFormats = {
  'da-DK': numberBase,
  'en-GB': numberBase,
  'en-US': numberBase,
  'de-DE': numberBase,
  'lv-LV': numberBase,
  'sv-SE': numberBase,
  'pl-PL': numberBase
};

// Relevant links:
// https://phrase.com/blog/posts/nuxt-js-tutorial-i18n/ (This one is really good, it goes through EVERYTHING)
// https://i18n.nuxtjs.org/
// https://vue-i18n.intlify.dev/
export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'da-DK',
  fallbackLocale: 'da-DK',
  numberFormats
}));
